<div
  class="container more-information more-info-container"
  [ngClass]="moreInfoIsCollapsed ? 'bg-white' : 'bg-grey'"
>
  <h2
    class="modal-title-info more-information more-info-title"
    *ngIf="moreInfoIsCollapsed"
  >
    <span *ngIf="isOrderDetails">
      {{ 'ORDER-LIST-DETAILS.TITLE-MORE-INFO' | translate }}
    </span>
    <span *ngIf="!isOrderDetails">
      {{ 'FREIGHT-EXCHANGE-DETAILS.TITLE-INSTRUCTIONS' | translate }}
    </span>
  </h2>
  <div [ngbCollapse]="moreInfoIsCollapsed" id="collapseMoreInfo">
    <div id="tab-remarks" class="more-info-tab">
      <mat-tab-group id="more-info-tab" class="custom-tabs">
        <mat-tab [label]="this.infoLabel">
          <div
            [ngClass]="
              moreInfoIsCollapsed == true
                ? 'container-grey-close'
                : 'container-grey-open'
            "
            id="moreInfoContainer"
          >
            <div class="card-body remark-tab-content-max-height">
              <mat-form-field appearance="fill" class="remarks-field">
                <textarea
                  disabled
                  class="order-instructions"
                  readonly
                  matInput
                  cdkTextareaAutosize
                  [value]="remark"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-tab>
        <mat-tab
          id="tab-docs"
          class="more-info-tab"
          label="{{ 'INSTRUCTION-DOCS.DOCUMENTS-TAB' | translate }}"
        >
          <div
            class="documents-tab container-white-open doc-tab-content-max-height"
            [ngClass]="[
              moreInfoIsCollapsed == true
                ? 'container-grey-close'
                : 'container-grey-open',
            ]"
          >
            <h3
              class="container-information-txt mobile-font-size-details-on-grey container-row-grey"
            >
              <ul *ngIf="customerHasIntructionDocs; else noDocuments">
                <span>
                  {{ 'INSTRUCTION-DOCS.DOCUMENT-NAME' | translate }}
                </span>
                <span class="last-modified-date">
                  {{ 'INSTRUCTION-DOCS.LAST-MODIFIED-DATE' | translate }}
                </span>
                <br />
                <br />
                <li
                  class="list-element"
                  *ngFor="let fileElement of instructionDocs"
                >
                  <div
                    #tooltip="matTooltip"
                    (click)="toggleTooltip(tooltip)"
                    class="link"
                    (click)="view(fileElement)"
                    [matTooltip]="fileElement.name"
                    [matTooltipDisabled]="!isDesktop"
                    matTooltipClass="filename-tooltip"
                  >
                    {{ formatName(fileElement.name) }}
                  </div>
                  <div class="last-modified-date">
                    {{
                      commonUtils.formatDateTime(fileElement.lastModifiedDate)
                    }}
                  </div>
                </li>
              </ul>
              <ng-template #noDocuments>
                <app-no-data
                  [infoText]="'INSTRUCTION-DOCS.NO-DOCUMENTS-AVAILABLE'"
                >
                </app-no-data>
              </ng-template>
            </h3>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <em
    class="details-container-btn-extra collapsible-panel more-info"
    [ngClass]="
      moreInfoIsCollapsed == true ? 'fa fa-angle-down' : 'fa fa-angle-up'
    "
    (click)="toggleMoreInfoCollapse()"
  >
  </em>
</div>
